/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `cut` - 컷
 * `crossfade` - 크로스페이드
 * `fade_to_black` - 페이드 투 블랙
 * `dissolve` - 디졸브
 */
export type TransitionTypeEnum =
  (typeof TransitionTypeEnum)[keyof typeof TransitionTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransitionTypeEnum = {
  cut: "cut",
  crossfade: "crossfade",
  fade_to_black: "fade_to_black",
  dissolve: "dissolve",
} as const;
